import { useEffect, useState } from "react";
import { Flame, Eye, Rocket } from "lucide-react";
import api from "./api";

// Per-category visual identity. Distinct accents (not a generic purple gradient):
// roast = molten orange, judge = electric cyan, validate = signal green.
export const CATEGORY_META = {
  roast: { icon: Flame, accent: "#ff4500", soft: "rgba(255,69,0,0.12)", tag: "🔥" },
  judge: { icon: Eye, accent: "#22d3ee", soft: "rgba(34,211,238,0.12)", tag: "👀" },
  validate: { icon: Rocket, accent: "#34d399", soft: "rgba(52,211,153,0.12)", tag: "🚀" },
};

export const catMeta = (key) => CATEGORY_META[key] || CATEGORY_META.roast;

let _cache = null;
export function useRoastLitConfig() {
  const [cfg, setCfg] = useState(_cache);
  useEffect(() => {
    if (_cache) return;
    (async () => {
      try {
        const r = await api.get("/verdictly/config");
        _cache = r.data;
        setCfg(r.data);
      } catch (e) { /* ignore */ }
    })();
  }, []);
  return cfg;
}

// Progressive-reveal step labels shared by the result views.
export const REVEAL_STEPS = ["headline", "concern", "responses"];
